import React from 'react';
import ErrorBoundary from './ErrorBoundary';

const FormErrorBoundary = ({ children, formName = 'form' }) => {
  return (
    <ErrorBoundary
      fallbackMessage={`There was an error loading the ${formName}. Your data has been preserved and you can try again.`}
    >
      {children}
    </ErrorBoundary>
  );
};

export default FormErrorBoundary;
